module.exports = __webpack_public_path__ + "static/otrofanowei-8646a26d0bfcefba84d749abec88dcf3.png";